import React, { useEffect, useMemo, useState } from 'react'
import ModalAsyncWait from 'components/modal/ModalAsyncWait'
import PropTypes from 'prop-types'
import { useMatch } from 'react-router-dom'

const AsyncModalContext = React.createContext({})

export function AsyncModalProvider({ children }) {
  const [show, setShow] = useState(false)
  const [message, setMessage] = useState('Lorem ipsum')

  useEffect(() => {
    document.body.style.overflow = 'scroll'
  }, [show])

  const ctxValue = useMemo(() => {
    return { show: setShow, setMessage }
  }, [setShow, setMessage])

  return (
    <AsyncModalContext.Provider value={ctxValue}>
      <ModalAsyncWait show={show} message={message} />
      {children}
    </AsyncModalContext.Provider>
  )
}

AsyncModalProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default AsyncModalContext
